<template>
  <el-container class="container">
    <el-header class="header-style">
      <el-divider content-position="left">小程序支付订单</el-divider>
      <el-row>
        <el-col :span="24">
          <el-input
            style="width: auto"
            v-model="searchArr.out_trade_no"
            size="mini"
            placeholder="输入订单号筛选"
            @input="handleOutTradeNoChange"
          ></el-input>
          <el-popover placement="bottom-start" v-model="visible" width="450">
            <el-form :model="searchArr" ref="searchForm" label-width="100px">
              <el-form-item label="下单业务">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.salesman_id"
                  placeholder="请选择下单业务"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="支付人/手机号" prop="payuser_id">
                <el-input
                  v-model="searchArr.payuser_id"
                  size="mini"
                  placeholder="支付人 / 手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="支付时间" prop="success_time">
                <el-date-picker
                  v-model="searchArr.success_time"
                  type="daterange"
                  range-separator="至"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="创建时间" prop="created_at">
                <el-date-picker
                  v-model="searchArr.created_at"
                  type="daterange"
                  range-separator="至"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="支付成功" name="SUCCESS"></el-tab-pane>
        <el-tab-pane label="未支付" name="NOTPAY"></el-tab-pane>
        <el-tab-pane label="支付中" name="USERPAYING"></el-tab-pane>
        <el-tab-pane label="支付失败" name="PAYERROR"></el-tab-pane>
        <el-tab-pane label="已关闭" name="CLOSED"></el-tab-pane>
        <el-tab-pane label="已撤销" name="REVOKED"></el-tab-pane>
        <el-tab-pane label="已退款" name="REFUND"></el-tab-pane>
      </el-tabs>

      <el-table
        ref="table_list"
        height="calc(100vh - 326px)"
        :data="pageData"
        size="mini"
        border
        style="width: 100%; overflow-x: auto"
        v-cloak
      >
        <el-table-column label="订单号" width="200" fixed>
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              style="padding: 0; border: none"
              slot="reference"
              @click="handleShowCommodity(scope.row, scope.row.user_info)"
              >{{ scope.row.out_trade_no }}</el-link
            >
            <!-- <el-link
              type="primary"
              v-else-if="scope.row.pcpayer && scope.row.pcpayer.user"
              :underline="false"
              style="padding: 0; border: none"
              slot="reference"
              @click="handleShowCommodity(scope.row, scope.row.pcpayer.user)"
              >{{ scope.row.out_trade_no }}</el-link
            > -->
          </template>
        </el-table-column>
        <el-table-column label="交易号" width="230">
          <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" width="200">
          <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.description }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付人" prop="out_trade_no">
          <template slot-scope="scope">
            <el-link
              type="primary"
              v-if="scope.row.user_info"
              :underline="false"
              class="hide-style"
              slot="reference"
              @click="handleShowPayerContent(scope.row, scope.row.user_info)"
              >{{ scope.row.user_info.name }}</el-link
            >
            <!-- <el-link
              type="primary"
              v-else-if="scope.row.pcpayer && scope.row.pcpayer.user"
              :underline="false"
              class="hide-style"
              slot="reference"
              @click="handleShowPayerContent(scope.row, scope.row.pcpayer.user)"
              >{{ scope.row.pcpayer.user.name }}</el-link
            > -->
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phone" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.user_info">
              <span class="hide-style">
                <el-link
                  style="color: #409eff; cursor: pointer"
                  @click="openPhoneFromDraw(scope.row.user_info.phone)"
                  >{{ scope.row.user_info.phone.substring(0, 5) + "..." }}</el-link
                >
                <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                  <i
                    @click="makePhone(scope.row.user_info.phone)"
                    class="el-icon-phone-outline"
                    style="color: #409eff; cursor: pointer"
                  ></i>
                </el-tooltip>
              </span>
            </div>
            <!-- <div
              v-else-if="scope.row.pcpayer && scope.row.pcpayer.user"
              :content="scope.row.pcpayer.user.phone"
              placement="top"
            >
              <span class="hide-style">
                <el-link
                  style="color: #409eff; cursor: pointer"
                  @click="openPhoneFromDraw(scope.row.pcpayer.user.phone)"
                >
                  {{ scope.row.pcpayer.user.phone.substring(0, 5) + "..." }}</el-link
                >
                <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                  <i
                    @click="makePhone(scope.row.pcpayer.user.phone)"
                    class="el-icon-phone-outline"
                    style="color: #409eff; cursor: pointer"
                  ></i>
                </el-tooltip>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="是否线索">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
              type="primary"
              :underline="false"
              style="padding: 0; border: none; color: #409eff"
              slot="reference"
              @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
            >
              <el-tooltip content="未认领" placement="top">
                <span class="hide-style" content="是">是</span>
              </el-tooltip>
            </el-link>
            <el-link
              v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
              type="primary"
              :underline="false"
              style="padding: 0; border: none; color: #409eff"
              slot="reference"
              @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
            >
              <el-tooltip
                :content="scope.row.publicthread.admin.username"
                placement="top"
              >
                <span class="hide-style" content="是">是</span>
              </el-tooltip>
            </el-link>
            <span v-else class="hide-style" content="否">否</span>
          </template>
        </el-table-column>
          <el-table-column
              v-if="activeName === 'NOTPAY'"
              label="是否意向"
              :render-header="historyBuyRecordHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.haspayed.length !== 0"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowHistoryOrderRecordOpen(scope.row, scope.row.haspayed)"
                >
                  <el-tooltip content="是" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
        <el-table-column
          label="下单业务"
          :render-header="downOrderrenderHeader"
          width="100"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
              scope.row.salesman ? scope.row.salesman.username : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="当前业务"
          :render-header="currentRenderHeader"
          width="100"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.user_info && scope.row.user_info.business
              "
            >
              <span class="hide-style">{{ scope.row.user_info.business.username }}</span>
            </div>
            <!-- <div
              v-else-if="
                scope.row.pcpayer &&
                scope.row.pcpayer.user &&
                scope.row.pcpayer.user.business
              "
            >
              <span class="hide-style">{{
                scope.row.pcpayer.user.business.username
              }}</span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="total" width="200">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.trade_state === '未支付'"
              type="primary"
              style="padding: 0; border: 0"
              slot="reference"
              @click="handleUpTotal(scope.row)"
              >{{ scope.row.total }}</el-link
            >
            <span v-else>{{ scope.row.total }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易状态" prop="trade_state"></el-table-column>
        <el-table-column label="支付时间" prop="success_time" width="140">
          <template slot-scope="scope">
            <span class="hide-style">
              <!-- {{ scope.row.success_time }} -->
              <date-formatter :date-value="scope.row.success_time"></date-formatter>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="140">
          <template slot-scope="scope">
            <span class="hide-style">
              <!-- {{ scope.row.created_at }} -->
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" prop="refund_status">
          <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.refund_status }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-dropdown
              trigger="click"
              style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff"
            >
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.trade_state === '支付成功' && !scope.row.refund_status"
                  @click.native="handRefund(scope.row)"
                  ><span><img class="icon-class" src="/static/refund.svg" /></span
                  >退款</el-dropdown-item
                >
                <el-dropdown-item>
                  <el-radio-group
                    v-model="statusRadioA[scope.$index]"
                    size="mini"
                    @change="updateOrderShowStatusA($event, scope.row.out_trade_no)"
                  >
                    <el-radio-button :label="1">开启</el-radio-button>
                    <el-radio-button :label="0">隐藏</el-radio-button>
                  </el-radio-group>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        class="tr mt-10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :current-page.sync="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOption.total"
        background
      >
      </el-pagination>
    </el-footer>

    <el-dialog
      title="修改金额"
      :visible.sync="totalVisible"
      width="40%"
      :before-close="handleTotalClose"
    >
      <div>
        <el-input v-model="changeTotal" size="mini"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleTotalSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title=""
      :visible.sync="phoneFromDraw"
      direction="rtl"
      :before-close="closePhoneFromDraw"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: large"></span>
      </template>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'订单信息： ' + payer.user_trade_no"
      :visible.sync="handleRecordDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      size="50%"
      :before-close="handleLookDrawerBeforeClose"
    >
      <div class="drawer-title" slot="title">订单信息： {{ payer.user_trade_no }}</div>
      <el-tabs type="border-card" style="margin: 0 0.4rem">
        <el-tab-pane label="基本信息">
          <div
            class="popoverList"
            style="margin-bottom: 0.4rem; padding: 0px 0.2rem 0px 0.4rem"
          >
            <p style="margin-bottom: 0.2rem">订单号：{{ payer.user_trade_no }}</p>
          </div>
          <div
            class="popoverList"
            style="margin-bottom: 0.4rem; padding: 0px 0.2rem 0px 0.4rem"
          >
            <p style="margin-bottom: 0.2rem">货币类型：{{ payer.currency }}</p>
          </div>
          <div
            class="popoverList"
            style="margin-bottom: 0.4rem; padding: 0px 0.2rem 0px 0.4rem"
          >
            <p style="margin-bottom: 0.2rem">银行类型：{{ payer.bank_type }}</p>
          </div>
          <el-divider></el-divider>
          <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
            <div class="tabs_line">
              <h3 class="tabs-title">商品信息</h3>
            </div>
            <div class="popoverList" style="margin-top: 0.4rem">
              <p
                v-for="(service, index) in services"
                :key="index"
                style="margin-bottom: 0.2rem"
              >
                {{ service.name }} ——
                <span v-if="service.type !== '其他服务'">{{ service.price }}</span>
                <span v-if="service.type === '代理记账'">
                  —— {{ service.cycle_type }}</span
                >
              </p>
              <p v-if="remark" style="margin-top: 0.2rem">备注：{{ remark }}</p>
            </div>
            <el-divider></el-divider>
            <div class="tabs_line">
              <h3 class="tabs-title">支付人信息</h3>
            </div>
            <div class="popoverList" style="margin-top: 0.4rem">
              <p style="margin-bottom: 0.2rem">姓名：{{ payer.nickname }}</p>
              <p style="margin-bottom: 0.2rem">昵称：{{ payer.name }}</p>
              <p style="margin-bottom: 0.2rem">手机号：{{ payer.phone }}</p>
              <p>性别：{{ payer.sex }}</p>
            </div>
            <el-divider></el-divider>
            <div class="tabs_line">
              <h3 class="tabs-title">操作记录</h3>
            </div>
            <el-table
              :data="handRecordData"
              size="medium"
              style="width: 100%; margin-top: 0.2rem"
              v-cloak
            >
              <el-table-column
                label="操作人"
                prop="adminuser.username"
                width="100"
              ></el-table-column>
              <el-table-column label="内容" prop="content"></el-table-column>
              <el-table-column label="操作时间" prop="created_at"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="反馈记录" v-if="feedBackBlag === true">
          <feed-back
            :orderId="wxOrderId"
            :type="5"
            :isShow="true"
            :cType="checkType"
          ></feed-back>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <!-- 沟通记录弹窗 开始-->
    <el-drawer
      title="沟通记录"
      :visible.sync="chatRecordDrawer"
      direction="rtl"
      :before-close="handleChatRecordBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
    <!-- 购买记录 开始-->
    <el-drawer
      title="购买记录"
      :visible.sync="historyBuyRecordDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-table
          :data="historyBuyRecord"
          size="small"
          border
          style="width: 100%; margin-top: 0.2rem"
          v-cloak
        >
          <el-table-column
            label="订单号"
            prop="out_trade_no"
            width="170"
          ></el-table-column>
          <el-table-column label="支付人">
            <template slot-scope="scope">
              <span>{{
                scope.row.user_info ? scope.row.user_info.name : ''
              }}</span>
              <!-- <span v-else-if="payuser.pcpayer && payuser.pcpayer.user">{{
                payuser.pcpayer.user.name
              }}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="description"></el-table-column>
          <el-table-column label="金额" prop="total">
            <template slot-scope="scope">
              <span>{{ scope.row.total }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易状态" prop="trade_state"></el-table-column>
          <el-table-column label="支付时间" prop="success_time" width="140">
            <template slot-scope="scope">
              <date-formatter :date-value="scope.row.success_time"></date-formatter>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="140">
            <template slot-scope="scope">
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
            </template>
          </el-table-column>
          <el-table-column label="退款状态" prop="refund_status"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 购买记录 结束-->
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer
      title="支付人详情及公司概况"
      :visible.sync="handlePayerContentDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="50%"
      class="PayerContent"
    >
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order
            :PayerData="userData"
            :ThreadData="ThreadData"
            :PayerCompanyData="PayerCompanyData"
            :userOrderData="userOrderData"
          >
            <div class="hide-style">当前订单号：{{ CurrentClickOrderNo }}</div>
          </userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 同步订单至订单列表 -->
    <el-dialog title="选择订单类型" :visible.sync="orderRegTypeDrawer" width="25%">
      <el-row style="width: 100%">
        <el-col :span="5" style="margin-top: 0.16rem">订单类型</el-col>
        <el-col :span="17" :offset="2">
          <el-select
            v-model="tycSyncSingleOrder.orderRegType"
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="reg in orderRegTypes"
              :key="reg.order_reg_id"
              :label="reg.order_reg_name"
              :value="reg.order_reg_id"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="tycSyncSingleOrder.orderRegType === 5" style="margin-top: 0.3rem">
        <el-col :span="5" style="margin-top: 0.16rem">单品</el-col>
        <el-col :span="17" :offset="2">
          <el-select
            v-model="tycSyncSingleOrder.mealSingles"
            multiple
            filterable
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option
              v-for="orderMeal in mealSingles"
              :key="orderMeal.item_id"
              :label="orderMeal.item_name"
              :value="orderMeal.item_id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleSubmitSyncOrder"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import ChatRecord from "common/ChatRecord";
import CompanyInfo from "common/CompanyInfo";
import UserwithOrder from "common/UserWithOrder";
import MakePhone from "common/MakePhone";
import FeedBack from "common/FeedBack";
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "WeAppPayOrders",
  components: {
    ChatRecord,
    CompanyInfo,
    UserwithOrder,
    MakePhone,
    FeedBack,
    DateFormatter,
  },
  data() {
    return {
      phoneFrom_phone: [],
      phoneFromDraw: false,
      // 选项卡初始化默认值
      activeName: "SUCCESS",
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      // 是否显示订单
      statusRadioA: [],
      statusRadioB: [],
      statusRadioC: [],
      outTradeNo: false,
      handleRecordDrawer: false,
      handRecordData: [], // 初始化操作记录
      historyBuyRecordDrawer: false,
      visible: false,
      adminUsers: [],
      searchArr: {
        out_trade_no: "",
        salesman_id: "",
        trade_state: "SUCCESS",
        // 支付人信息
        payuser_id: "",
        success_time: "",
        created_at: "",
      },
      services: [],
      remark: "",
      payer: {
        nickname: "",
        name: "",
        phone: "",
        sex: "",
        user_trade_no: "",
        currency: "",
        bank_type: "",
      },
      totalVisible: false,
      changeTotalId: "",
      changeTotal: 0,
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      // 历史购买记录
      historyBuyRecord: [],
      payuser: "",
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      PayerCompanyData: [],
      payerShowTab: "1",
      companyInfoDrawer: false,
      companyInfoId: null,
      userOrderData: [],
      CurrentClickOrderNo: "",
      // 时间控件组件初始化
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      mealSingles: [],
      orderRegTypes: [],
      orderRegTypeDrawer: false,
      tycSyncSingleOrder: {
        orderRegType: null,
        orderNo: null,
        mealSingles: [],
      },
      checkType: this.$feedBackConfig.unpay_order,
      wxOrderId: null,
      feedBackBlag: false,
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 同步至订单列表
    syncWePayOrderToOrder(row) {
      this.orderRegTypeDrawer = true;
      this.tycSyncSingleOrder.orderNo = row.out_trade_no;
    },
    handleSubmitSyncOrder() {
      if (!this.tycSyncSingleOrder.orderRegType) {
        this.$message.error("请选择订单类型！");
        return;
      }
      this.$axios
        .post("/api/admin/we_pay_order/sync_mini_order", this.tycSyncSingleOrder)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.getPageData();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    makePhone(phone) {
      let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

      if (!regPhone.test(phone)) {
        this.$message.error("手机号格式错误");
        return;
      }
      this.$axios.post("/api/admin/call_logs/" + phone).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success("调用成功，请注意接听来电");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    getPageData() {
      var pageSize = this.pageOption.pageSize;
      var tradeNo = this.searchArr.out_trade_no;
      var saler = this.searchArr.salesman_id;
      var state = this.searchArr.trade_state;
      var payer = this.searchArr.payuser_id;
      var stime = this.searchArr.success_time;
      var crat = this.searchArr.created_at;
      this.$axios
        .get("/api/admin/we_app_pay_orders?page=" + this.pageOption.currentPage, {
          params: {
            pageSize: pageSize,
            trade_no: tradeNo,
            saler: saler,
            state: state,
            payer: payer,
            success_time: stime,
            crated_at: crat,
          },
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.pageData.data;
            this.pageOption.total = data.data.pageData.total;
            this.adminUsers = data.data.adminUsers;
            this.orderRegTypes = data.data.orderRegs;
            this.mealSingles = data.data.mealSingles;
            this.outTradeNo = false;
            this.initRadio();
          }
        });
    },
    handleLookDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.handleRecordDrawer = false;
          this.wxOrderId = null;
          done();
        })
        .catch((_) => {});
    },
    // 更改订单显示状态(成功)
    updateOrderShowStatusA(val, outTradeNo) {
      let confirmTips = val === 1 ? "显示" : "隐藏";
      this.$confirm("确定将此订单状态设为" + confirmTips + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("api/admin/we_app_pay_orders/update_show_status", {
              out_trade_no: outTradeNo,
              show_status: val,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message({
                  type: "success",
                  message: data.msg,
                });
              }
            });
        })
        .catch(() => {
          this.initRadio();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    initRadio() {
      if (this.activeName === "SUCCESS") {
        this.pageData.map((item, index) => {
          if (item.show_status === 1) {
            this.statusRadioA[index] = 1;
          }
          if (item.show_status === 0) {
            this.statusRadioA[index] = 0;
          }
        });
      } else if (this.activeName === "NOTPAY") {
        this.pageData.map((item, index) => {
          if (item.show_status === 1) {
            this.statusRadioB[index] = 1;
          }
          if (item.show_status === 0) {
            this.statusRadioB[index] = 0;
          }
        });
      } else if (this.activeName === "REFUND") {
        this.pageData.map((item, index) => {
          if (item.show_status === 1) {
            this.statusRadioC[index] = 1;
          }
          if (item.show_status === 0) {
            this.statusRadioC[index] = 0;
          }
        });
      }
    },
    LastWeek() {
      const end = new Date();
      const start = new Date();
      const lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);
      return [start, end];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    thisMonth() {
      const end = new Date();
      const start = new Date();
      // 方法1
      const endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    LastMonth() {
      const end = new Date();
      const start = new Date();
      const year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end];
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    handleShowHistoryOrderRecordOpen(payuser, payeddata) {
      this.historyBuyRecordDrawer = true;
      this.historyBuyRecord = payeddata;
      this.payuser = payuser;
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    handleShowCommodity(row, user) {
      // console.log(row)
      this.$axios
        .post("/api/admin/we_app_pay_order/services", { id: row.oid })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.services = data.data.services;
            this.handRecordData = data.data.handleRecords;
            this.remark = row.remark;
            this.payer.name = user.name;
            this.payer.nickname = user.nickname;
            this.payer.user_trade_no = row.out_trade_no;
            this.payer.phone = user.phone;
            this.payer.sex = user.sex;
            this.payer.currency = row.currency;
            this.payer.bank_type = row.bank_type;
            setTimeout(() => {
              this.wxOrderId = row.oid;
            }, 100);
          } else {
            this.$message.error(data.msg);
          }
        });
      this.handleRecordDrawer = true;
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios.post("/api/customer/get_customer_order", { id: row.id }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.userOrderData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row, user) {
      this.ThreadData = row.publicthread;
      this.userData = user;
      this.PayerCompanyData = user.company;
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = user.business.username;
        }
      }
      this.handelOpenUserOrder(row);
      this.CurrentClickOrderNo = row.out_trade_no;
      this.handlePayerContentDrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          done();
        })
        .catch((_) => {});
    },
    CompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    handleOutTradeNoChange(val) {
      if (this.outTradeNo) return;
      this.outTradeNo = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.getPageData();
      }, 800);
    },
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    submitForm(formName) {
      this.visible = false;
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleUpTotal(row) {
      this.changeTotalId = row.oid;
      this.changeTotal = row.total;
      this.totalVisible = true;
    },
    handleTotalClose(done) {
      this.changeTotalId = "";
      this.changeTotal = 0;
      done();
    },
    handleTotalSub() {
      if (!this.changeTotal) {
        this.$message.error("金额不能为空");
        return;
      }
      this.$axios
        .post("/api/admin/we_app_pay_orders/change_total", {
          total: this.changeTotal,
          id: this.changeTotalId,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getPageData();
            this.totalVisible = false;
            this.changeTotalId = "";
            this.changeTotal = 0;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handRefund(row) {
      this.$confirm("是否确定退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/api/admin/we_app_pay_orders/refund/" + row.oid)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.getPageData();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        })
        .catch(() => {});
    },
    historyBuyRecordHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          "el-tooltip",
          {
            props: {
              content: (function () {
                return "指当前订单支付人是否有过成交记录";
              })(),
              placement: "top",
            },
          },
          [
            h("span", {
              class: {
                "el-icon-question": true,
              },
            }),
          ]
        ),
      ];
    },
    downOrderrenderHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          "el-tooltip",
          {
            props: {
              content: (function () {
                return "指客户下单时对接的业务人员";
              })(),
              placement: "top",
            },
          },
          [
            h("span", {
              class: {
                "el-icon-question": true,
              },
            }),
          ]
        ),
      ];
    },
    currentRenderHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          "el-tooltip",
          {
            props: {
              content: (function () {
                return "指当前客户对接的业务人员";
              })(),
              placement: "top",
            },
          },
          [
            h("span", {
              class: {
                "el-icon-question": true,
              },
            }),
          ]
        ),
      ];
    },
    // 选项卡默认点击事件
    handleClick(tab, event) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        // 成功的订单
        this.searchArr.trade_state = "SUCCESS";
        this.feedBackBlag = false;
      } else if (parseInt(tab.index) === 1) {
        // 待支付的订单
        this.searchArr.trade_state = "NOTPAY";
        this.feedBackBlag = true;
      } else if (parseInt(tab.index) === 2) {
        // 支付中的订单
        this.searchArr.trade_state = "USERPAYING";
        this.feedBackBlag = false;
      } else if (parseInt(tab.index) === 3) {
        // 支付失败的订单
        this.searchArr.trade_state = "PAYERROR";
        this.feedBackBlag = false;
      } else if (parseInt(tab.index) === 4) {
        // 已关闭的订单
        this.searchArr.trade_state = "CLOSED";
        this.feedBackBlag = false;
      } else if (parseInt(tab.index) === 5) {
        // 已撤销的订单
        this.searchArr.trade_state = "REVOKED";
        this.feedBackBlag = false;
      } else if (parseInt(tab.index) === 6) {
        // 转入退款的订单
        this.searchArr.trade_state = "REFUND";
        this.feedBackBlag = false;
      }
      this.pageOption.currentPage = 1;
      this.getPageData();
      this.$nextTick(() => {
        this.$refs.table_list.doLayout();
      });
    },
    handlePayerClick(tab, event) {
      console.log(event);
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
  },
  mounted() {
    this.getPageData();
    // const container = document.querySelector('.container');
    // container.style.height = `${window.innerHeight}px`;
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.icon-class {
  width: 16px;
  margin-bottom: 0.06rem;
  margin-right: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0;
  border: none;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.el-drawer .el-form-item {
  margin-bottom: 0.3rem !important;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}

.container {
  marginLeft();
  max-height: 100vh;
  .header-style {
    height: 100px !important;
    padding: 0px !important;
    .tr {
      text-align: right;
    }

    .mt-10 {
      margin-top: 0.2rem;
    }

    .PayerContent >>> .el-link--inner {
      font-size: 12px !important;
    }
  }
  .main-style {
    padding: 0px !important;
    overflow-y: auto;
  }

  .footer-style {
    text-align: right;
    // background-color: #f5f5f5;
    .el-pagination {
      padding-top: 25px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/we_app_pay_orders/WeAppPayOrders.vue